export const ELIGIBILITY_2_CONSTANTS = {
  COMPONENT_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Eligibility Criteria",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Section heading",
      required: false,
      defaultValue: "Eligibility Criteria",
    },
    {
      fieldName: "title_text_color",
      label: "Heading color",
      value: "#F8F9FA",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#F8F9FA",
    },
    {
      fieldName: "background_gradient_start_color",
      label: "Background gradient start",
      value: "#0A3D5B",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#0A3D5B",
    },
    {
      fieldName: "background_gradient_end_color",
      label: "Background gradient end",
      value: "#0A3D5B",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#0A3D5B",
    },
    {
      fieldName: "background_gradient_angle",
      label: "Background gradient angle",
      value: "180deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 180deg",
      required: false,
      defaultValue: "180deg",
    },
    {
      fieldName: "category_border_color",
      label: "Category border color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "category_active_text_color",
      label: "Active category text color",
      value: "#0A3D5B",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#0A3D5B",
    },
    {
      fieldName: "category_active_background_color",
      label: "Active category background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "category_inactive_text_color",
      label: "Inactive category text color",
      value: "#F8F9FA",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#F8F9FA",
    },
    {
      fieldName: "content_text_color",
      label: "Rich text content color",
      value: "#F8F9FA",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#F8F9FA",
    },
    {
      fieldName: "button_text",
      label: "CTA button text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "button_text_color",
      label: "CTA text color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#222222",
    },
    {
      fieldName: "button_color",
      label: "CTA background color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "read_more_url",
      label: "Read more URL (if empty, CTA opens lead form)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://... (leave empty to open lead form)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      required: false,
      defaultValue: false,
    },
  ],

  CATEGORY_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Category label (tab)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. For Indian students",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "content",
      label: "Category content",
      value: "",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "order_index",
      label: "Display order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Active",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  itemTableFieldsConfig: [] as any[],
};
